<app-horizinns-loader></app-horizinns-loader>
<div class="horizinns-container center">
    <div class="mat-row margin-auto text-center">
        <img src="/assets/images/logo_full_900.png" class="main-logo" alt="Horizinns logo" />
        <div class="welcome-row">
            <mat-card class="welcome-card">
                <mat-card-content class="content">
                    <div class="left-side">
                        <h1><span class="cs-font top-tagline1"><i>re</i></span><span class="top-tagline2">TREAT</span></h1>
                        <h1 class="uppercase bottom-tagline">yourself</h1>
                    </div>
                    <div class="divider" role="separator" aria-label="Divider"></div>
                    <div class="divider-vertical" role="separator" aria-label="Divider"></div>
                    <div class="right-side">
                        <h3 class="uppercase" style="margin-bottom: 2px;">explore</h3>
                        @defer (on immediate) {
                            <ng-container *ngIf="activeStates$ | async as activeStates">
                                @if (activeStates.length > 0) {
                                    <div>
                                        <mat-form-field appearance="outline" class="full-width">
                                            <mat-select [(ngModel)]="searchText" (click)="select()">
                                                <mat-option value="null">Select a State</mat-option>
                                                <mat-option *ngFor="let state of activeStates" [value]="state.code">
                                                    {{ state.name }}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>   
                                    </div>
                                    <div>
                                        <!-- <button mat-flat-button appGlassPill="solid-blue" color="accent" type="button" (click)="getResults()">
                                            <i class="fa-solid fa-magnifying-glass-location"></i>
                                            View Properties
                                        </button> -->
                                        <button mat-flat-button class="metallic-text-btn-green" type="button" (click)="getResults()">
                                            <i class="fa-solid fa-magnifying-glass-location"></i>
                                            View Properties
                                        </button>
                                        <!-- <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="getResults()">
                                        <i class="fa-solid fa-magnifying-glass-location"></i>
                                        View Properties
                                    </button> -->
                                    </div>
                                } @else {
                                    <!-- <button mat-raised-button color="accent" type="button" (click)="getResults()">
                                        <i class="fa-solid fa-magnifying-glass-location"></i>
                                        View Properties
                                    </button> -->
                                    <button mat-flat-button class="metallic-text-btn-green" type="button" (click)="getResults()">
                                        <i class="fa-solid fa-magnifying-glass-location"></i>
                                        View Properties
                                    </button>
                                    <!-- <button mat-flat-button class="metallic-text-btn-blue" type="button" (click)="getResults()">
                                        <i class="fa-solid fa-magnifying-glass-location"></i>
                                        View Properties
                                    </button> -->
                                }
                            </ng-container>
                        } @loading {
                            <div class="skeleton-loader skeleton-search"></div>
                        }
                    </div>
                </mat-card-content>
            </mat-card>
        </div>
    </div>
</div>



<section class="about-container">
    <h2 class="section-title">Journey With Horizinns</h2>
    
    <div class="process-grid" appScrollProgress>

        <div class="journey-line"></div>
        
        <div class="process-step">
            <div class="icon-wrapper">
                <span class="material-symbols-outlined">travel_explore</span>
            </div>
            <div class="step-content">
                <h3>Find Your Space</h3>
                <p>Browse unique listings in top U.S. destinations.</p>
            </div>
        </div>

        <div class="process-step">
            <div class="icon-wrapper">
                <span class="material-symbols-outlined">book_online</span>
            </div>
            <div class="step-content">
                <h3>Reserve Directly</h3>
                <p>Connect with hosts instantly. No middleman.</p>
            </div>
        </div>

        <div class="process-step">
            <div class="icon-wrapper">
                <span class="material-symbols-outlined">savings</span>
            </div>
            <div class="step-content">
                <h3>Save on Fees</h3>
                <p>Zero booking fees for renters. Keep your money.</p>
            </div>
        </div>

        <div class="process-step">
            <div class="icon-wrapper">
                <span class="material-symbols-outlined">flight_takeoff</span>
            </div>
            <div class="step-content">
                <h3>Get Away</h3>
                <p>Enjoy your retreat knowing you got the best deal.</p>
            </div>
        </div>

    </div>

    <app-featured-globe></app-featured-globe>
</section>

<!-- <div class="about-container">
    <div class="about-row" style="display:flex; justify-content: center; align-items: center; width: 100%;">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">travel_explore</span>
        <h2>Find Your Space</h2>
    </div>

    <div class="about-row" style="display:flex; justify-content: center; align-items: center; width: 100%;">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">arrow_cool_down</span>
    </div>

    <div class="about-row" style="display:flex; justify-content: center; align-items: center; width: 100%;">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">book</span>
        <h2>Reserve Your Place</h2>
    </div>

    <div class="about-row" style="display:flex; justify-content: center; align-items: center; width: 100%;">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">arrow_cool_down</span>
    </div>

    <div class="about-row" style="display:flex; justify-content: center; align-items: center; width: 100%;">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">money_bag</span>
        <h2>Fees You Save</h2>
    </div>
    
    <div class="about-row" style="display:flex; justify-content: center; align-items: center; width: 100%;">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">arrow_cool_down</span>
    </div>

    <div class="about-row">
        <span class="material-symbols-outlined" style="font-size: 58px; margin-top: -10px; margin-right: 24px; color: #3d99b1;">travel</span>
        <h2>Get Away</h2>
    </div>
</div> -->
